'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const utils_hashString = require('./hashString.cjs.js');

const createUniqueCustomProperty = (block, propertyName) => {
  const hash = utils_hashString.hashString("design-system" + block + propertyName);
  return `--${block}-${propertyName}-${hash}`;
};
const createUniqueCustomProperties = (block, propertyNames) => {
  return propertyNames.reduce((accum, propertyName) => {
    accum[propertyName] = createUniqueCustomProperty(block, propertyName);
    return accum;
  }, {});
};

exports.createUniqueCustomProperties = createUniqueCustomProperties;
exports.createUniqueCustomProperty = createUniqueCustomProperty;
//# sourceMappingURL=createUniqueCustomProperty.cjs.js.map
